export const EventDescription = ({ text, className = "", preview = false, style }) => {
  if (!text) return null;

  return (
    <div
      className={`${preview ? "line-clamp-2" : "whitespace-pre-wrap"} ${className}`}
      style={style}
    >
      {text}
    </div>
  );
};
